import NavBar from "./Components/NavBar";
import "./CSS/reporte.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
  orderBy,
} from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import { db } from "./FirebaseConfig/firebase";
import Button from "@mui/material/Button";

import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { utils } from "xlsx";

const MySwal = withReactContent(Swal);
function ReporteParrillas() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [codigosList, setCodigosList] = useState([]);
  const [codIngeniero, setCodIngeniero] = useState();
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [fecha, setFecha] = useState(localStorage.getItem("fechaParrilla")); // xxxx/xx/xx
  const [fechaString, setFechaString] = useState(); // MOSTRAR BARRA DE CARGA
  const [elementos, setElementos] = useState([
    {
      nombre: "ZONA 1",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona1",
    },
    {
      nombre: "ZONA 2",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona2",
    },
    {
      nombre: "ZONA 3",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona3",
    },
    {
      nombre: "ZONA 4",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona4",
    },
    {
      nombre: "ZONA 5",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona5",
    },
    {
      nombre: "ZONA 6",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona6",
    },
    {
      nombre: "CAJA CHINA 1",
      imagen: "caja",
      estado: "disponible",
      id: "caja1",
    },
    {
      nombre: "CAJA CHINA 2",
      imagen: "caja",
      estado: "disponible",
      id: "caja2",
    },
  ]);



  //FOR DE FORS
  const buscarCodigos = async () => {
    const cuponesList = collection(db, `PARRILLAS`);
    const q = query(
      cuponesList,
      where("fecha", "==", fecha),
      orderBy("fecha", "desc")
    );

    const data = await getDocs(q);
    const formattedData = [];

    for (const doc of data.docs) {
      const invitadosRef = collection(doc.ref, "INVITADOS");
      const invitadosSnapshot = await getDocs(invitadosRef);

      const invitadosFormatted = invitadosSnapshot.docs.map((invitadoDoc) => {
        const { nombre, dni } = invitadoDoc.data();
        return `${nombre} (${dni})`;
      });
      const pagosInvitados = invitadosSnapshot.docs.map((invitadoDoc) => {
        const { estado } = invitadoDoc.data();
        return `${estado} `;
      });

	  const categoriasEdad = invitadosSnapshot.docs.map((invitadoDoc) => {
        const { categoriaEdad } = invitadoDoc.data();
        return `${categoriaEdad} `;
      });

      const parrillaData = {
        ...doc.data(),
        id: doc.id,
        invitados: invitadosFormatted.join("\r\n"),
        estadoPagos: pagosInvitados.join("\r\n"),
		categoriasEdad: categoriasEdad.join("\r\n"),

      };

      formattedData.push(parrillaData);
    }

    setCodigosList(formattedData);
    setDatosCargados(true);
  };


  const descargarTabla = () => {
    console.log(codigosList);

	const nuevaListaDeObjetos = [];

	// Itera a través de la lista de objetos originales
	codigosList.forEach((objeto) => {
	  // Divide la cadena de invitados en un arreglo de invitados
	  const invitadosArray = objeto.invitados.split('\n').map(invitado => invitado.trim());
	
	  // Divide la cadena de estados de pago en un arreglo de estados de pago
	  const estadosPagoArray = objeto.estadoPagos.split('\n').map(estado => estado.trim());

	 // Divide la cadena de estados de pago en un arreglo de estados de pago
	 const categoriaEdadArray = objeto.categoriasEdad.split('\n').map(estado => estado.trim());
	
	  // Itera a través de los invitados y crea un nuevo objeto por cada uno
	  invitadosArray.forEach((invitado, index) => {
		const nuevoObjeto = { ...objeto }; // Copia todos los datos del objeto original
		nuevoObjeto.invitado = invitado; // Agrega el invitado como una nueva propiedad
		nuevoObjeto.estadoPago = estadosPagoArray[index]; // Asigna el estado de pago correspondiente
		nuevoObjeto.categoriaEdad = categoriaEdadArray[index]; // Asigna el estado de pago correspondiente
		// Agrega el nuevo objeto a la nueva lista de objetos
		nuevaListaDeObjetos.push(nuevoObjeto);
	  });
	});
	
	// Ahora, nuevaListaDeObjetos contiene objetos extendidos por cada invitado
	console.log(nuevaListaDeObjetos);
	//setCodigosList(nuevaListaDeObjetos)
    
    if (nuevaListaDeObjetos.length == 0) {
      Swal.fire("ERROR", "No hay reservas para este dia", "error");
    } else {

      const dataWithHeader = [
        header,
        ...nuevaListaDeObjetos.map((item) => [
          item.cip,
          item.apellidos,
          item.nombre,
          elementos.find((elemento) => elemento.id === item.zona).nombre,
          item.invitado,
		  item.categoriaEdad,
          item.estadoPago,
		  item.observaciones,
          item.fechaReserva,
        ]),
      ];

      exportToXlsx(dataWithHeader);
    }
  };

  function exportToXlsx(data) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet["!rows"] = [
      {
        height: 30,
        cells: [{ style: { fill: { fgColor: { rgb: "FFFF0000" } } } }],
      },
    ];

    worksheet["!cols"] = [
      { wch: 10 }, // Ancho de la primera columna
      { wch: 20 }, // Ancho de la segunda columna
      { wch: 20 }, // Ancho de la tercera columna
      { wch: 20 },
      { wch: 40 },
	  { wch: 20 },
	  { wch: 20 },
      { wch: 40 },
      { wch: 30 },
    ];
    worksheet["!ref"] = `A2:${utils.encode_col(header.length - 1)}${
      data.length + 1
    }`;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const file = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

    const blob = new Blob([s2ab(file)], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    console.log(url);
    // Crear un enlace <a> para descargar el archivo
    const link = document.createElement("a");
    link.href = "data:application/octet-stream;base64," + btoa(file);
    link.download = `ReporteParrilla ${fechaString}.xlsx`;
    link.click();
    console.log(link.href);

    //saveAs(blob, "ReporteCupon.xlsx");
  }
  window._fetchBlob = function (url, fileExtension) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";

    xhr.onload = function () {
      if (xhr.status === 200) {
        var reader = new FileReader();
        reader.onloadend = function () {
          var base64data = reader.result;
          window.android.onBlobData(base64data); // Llamar a la función `onBlobData()` en Android para devolver los datos
        };
        reader.readAsDataURL(xhr.response);
      } else {
        console.error("Error al descargar el archivo Blob.");
      }
    };

    xhr.send();
  };
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }


  const header = [
    "CIP",
    "APELLIDOS",
    "NOMBRES",
    "ZONA RESERVADA",
    "INVITADOS",
	"CATEGORIA DE EDAD",
    "ESTADO DE PAGO",
	"OBSERVACIONES",
    "FECHA DE RESERVA",
  ];
  //cerrar cupones
  const cerrar = () => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      navigate("../panelCDA/zonaparrillas");
    } else {
      if (localStorage.getItem("nivelUsuario") == "admin") {
        navigate("../panelAdmin/zonaparrillas");
      } else {
        navigate("../login");
      }
    }
  };
  useEffect(() => {
    if (codIngeniero) {
      //console.log("Buenos dias estrellitas");
    } else {
    }
  }, [codIngeniero]);

  useEffect(() => {
    buscarCodigos();
    //fecha to string
    const opcionesDeFormato = { day: "numeric", month: "long" };
    setFechaString(
      new Date(fecha + "T17:00:00Z").toLocaleDateString(
        "es-ES",
        opcionesDeFormato
      )
    );
  }, []);

  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <NavBar
        titulo="REPORTES"
        nombre=""
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="reporte-cabecera">
        <h1 className="cd">
          Dia: {fechaString} , Zonas de parrilla reservadas :{" "}
          {codigosList.length}
        </h1>
      </div>
      <div style={{ paddingLeft: "50px" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            descargarTabla();
          }}
        >
          DESCARGAR REPORTE
        </Button>
      </div>

      <div className="reporte-tabla">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>CODIGO CIP USUARIO</b>
                </TableCell>
                <TableCell align="center">
                  <b>APELLIDOS</b>
                </TableCell>
                <TableCell align="center">
                  <b>NOMBRES</b>
                </TableCell>
                <TableCell align="center">
                  <b>ZONA RESERVADA</b>
                </TableCell>
                <TableCell align="center">
                  <b>INVITADOS</b>
                </TableCell>
				<TableCell align="center">
                  <b>CATEGORIA DE EDAD</b>
                </TableCell>
                <TableCell align="center">
                  <b>ESTADO DE PAGO</b>
                </TableCell>
				<TableCell align="center">
                  <b>OBSERVACIONES</b>
                </TableCell>
                <TableCell align="center">
                  <b>FECHA DE RESERVA</b>
                </TableCell>
                <TableCell align="center">
                  <b>TICKET</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codigosList.map((row) => (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.cip}</TableCell>
                  <TableCell align="center">{row.apellidos}</TableCell>
                  <TableCell align="center">{row.nombre}</TableCell>

                  <TableCell style={{ width: "3px" }} align="center">
                    {
                      elementos.find((elemento) => elemento.id === row.zona)
                        .nombre
                    }
                  </TableCell>
                  <TableCell align="center">
                    <Typography
                      variant="body2"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {row.invitados}
                    </Typography>
                  </TableCell>
				  <TableCell align="center">
                    <Typography
                      variant="body2"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {row.categoriasEdad}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography
                      variant="body2"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {row.estadoPagos}
                    </Typography>
                  </TableCell>
				  <TableCell align="center">{row.observaciones}</TableCell>
                  <TableCell align="center">{row.fechaReserva}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        window.open(`/eventoscip/#/zonaparrilla/${row.id}`, "_blank");
						//navigate(`#/zonaparrilla/${row.id}/`);

                      }}
                    >
                      Ver Entrada
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default ReporteParrillas;
